import "./ProfileLinkingLayoutComponent.scss";
import TabsWrapperComponent, {
    TabComponent,
    TabContentComponent, TabsComponent
} from "../../../../shared/components/tabs/TabsComponent";
import React, {useCallback, useEffect, useMemo, useState} from "react";

import {useSearchParams} from "react-router-dom";
import ButtonComponent from "../../../../shared/components/button/ButtonComponent";
import {APIConfig, ImageConfig, Misc} from "../../../../constants";
import TableWrapperComponent from "../../../../shared/components/table-wrapper/TableWrapperComponent";
import {ITableColumn} from "../../../../shared/models/table.model";
import {CommonService} from "../../../../shared/services";
import LinkComponent from "../../../../shared/components/link/LinkComponent";
import IconButtonComponent from "../../../../shared/components/icon-button/IconButtonComponent";
import DrawerComponent from "../../../../shared/components/drawer/DrawerComponent";
import * as Yup from "yup";
import _ from "lodash";
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import FormikInputComponent from "../../../../shared/components/form-controls/formik-input/FormikInputComponent";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import ProfileFoundCardComponent from "../../../../shared/components/profile-found-card/ProfileFoundCardComponent";
import AvatarComponent from "../../../../shared/components/avatar/AvatarComponent";
import ModalComponent from "../../../../shared/components/modal/ModalComponent";
import LottieFileGenarationComponent
    from "../../../../shared/components/lottie-file-genaration/LottieFileGenarationComponent";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";
import FormikPhoneInputComponent from "../../../../shared/components/formik-phone-input/FormikPhoneInputComponent";
import moment from "moment";
import LoaderComponent from "../../../../shared/components/loader/LoaderComponent";
import ReviewPendingComponent from "../review-pending/ReviewPendingComponent";
import ViewAccountDetailsComponent from "../view-account-details/ViewAccountDetailsComponent";
import RequestAccessFormComponent from "../request-access/RequestAccessFormComponent";
import SuccessStatusComponent from "../success-status/SuccessStatusComponent";
import ViewAccessDetailsComponent from "../view-access-details/ViewAccessDetailsComponent";
import ToolTipComponent from "../../../../shared/components/tool-tip/ToolTipComponent";

interface ProfileLinkingLayoutComponentProps {

}

const ProfileLinkingSteps: any[] = ["accountsICanAccess", "accountsThatHaveAccessToMyAccount"];

const requestAccessFormValidationSchema = Yup.object({
    client_id: Yup.string().required('Client ID is required'),
    first_name: Yup.string().required('First name is required'),
    last_name: Yup.string().required('Last name is required'),
    dob: Yup.date().required('Date of birth is required'),
    phone: Yup.string().required('Phone is required'),
    relationship: Yup.string().required('Relationship is required'),
    permission_type: Yup.mixed().required('Permission type is required'),

});

const upGradeProfileFormValidationSchema = Yup.object().shape({
    primary_email: Yup.string().nullable().email('Enter a valid email address')
        .max(100, 'Email cannot be more than 100 characters')
        .required('Email address is required'),
    primary_contact_info: Yup.object({
        phone: Yup.string().required('Phone Number is required').min(Misc.PHONE_NUMBER_MIN_LENGTH, 'enter a valid phone number'),
    })
})


const requestAccessInitialValues = {
    permission_type: "",
    client_id: "",
    phone: "",
    first_name: '',
    last_name: '',
    dob: '',
    request_type: ''

}


const accountDetailInitialValues = {
    permission_type: "",
}

const upGradeProfileInitialValues = {
    primary_email: "",
    primary_contact_info: {
        phone: ""
    },
}

const mutual_access_object = {
    title: "Mutual Access",
    code: "mutual",
}

const no_mutual_access_object = {
    title: "One-Way Access",
    code: "non_mutual",
}

const ProfileLinkingLayoutComponent = (props: ProfileLinkingLayoutComponentProps) => {


    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const [requestAccessFormInitialValues, setRequestAccessFormInitialValues] = useState<any>(_.cloneDeep(requestAccessInitialValues));
    const [accountDetailFormInitialValues, setAccountDetailsFormInitialValues] = useState<any>(_.cloneDeep(accountDetailInitialValues));
    // const [profileLinkingInitialValues] = useState<any>(_.cloneDeep(profileLinkingFormInitialValues));
    const [currentTab, setCurrentTab] = useState<any>("accountsICanAccess");
    const [searchParams, setSearchParams] = useSearchParams();
    const [isRequestAccessDrawerOpen, setIsRequestAccessDrawerOpen] = useState<boolean>(false);
    const [mode, setMode] = useState<'requestAccess' | 'grantAccess' | 'success'>("requestAccess");
    const [profileFound, setProfileFound] = useState<any>(null);
    const [isProfileUnlinkConfirmationModalOpen, setIsProfileUnlinkConfirmationModalOpen] = useState<boolean>(false);
    const [selectedProfile, setSelectedProfile] = useState<any>(null);
    const [isAccountDetailsDrawerOpen, setIsAccountDetailsDrawerOpen] = useState<boolean>(false);
    const [isUpdateProfileStatusDrawerOpen, setIsUpdateProfileStatusDrawerOpen] = useState<boolean>(false);
    const [isGrantAccessDrawerOpen, setIsGrantAccessDrawerOpen] = useState<boolean>(false);
    const [clientDetails, setClientDetails] = useState<any>(null);
    const [isRequestedAccessDrawerOpen, setIsRequestedAccessDrawerOpen] = useState<boolean>(false);
    const [cancelRequestLoading, setCancelRequestLoading] = useState<boolean>(false);
    const [viewDetailsStep, setViewDetailsStep] = useState<'view' | 'select'>('view');
    const [refreshToken, setRefreshToken] = useState<string>('');
    const [getRequestAccessDetailsData, setGetRequestAccessDetailsData] = useState<any>(null);
    const [isRequestDataDrawerOpen, setIsRequestDataDrawerOpen] = useState<boolean>(false);
    const [isRequestDataLoading, setIsRequestDataLoading] = useState<boolean>(false);
    const [isRequestDataLoaded, setIsRequestDataLoaded] = useState<boolean>(false);
    const [editAccessStep, setEditAccessStep] = useState<'view' | 'request' | 'grant' | 'success'>('view');
    const [isApproveClientRequestLoading, setIsApproveClientRequestLoading] = useState<boolean>(false);
    const currentStep = searchParams.get('currentStep');
    const [openWithdrawModal, setOpenWithdrawModal] = useState<boolean>(false);
    const [isRequestIsLoading, setIsRequestIsLoading] = useState<boolean>(false);
    const [count, setCount] = useState(0);

    useEffect(() => {
        let currentTab: any = searchParams.get("currentStep");
        if (currentTab) {
            if (!ProfileLinkingSteps.includes(currentTab)) {
                currentTab = "accountsICanAccess";
            }
        } else {
            currentTab = "accountsICanAccess";
        }
        setCurrentTab(currentTab);
    }, [searchParams]);

    const handleProfileUnlinkConfirmationModalOpen = useCallback(() => {
        setIsProfileUnlinkConfirmationModalOpen(true);
    }, []);

    const handleProfileUnlinkConfirmationModalClose = useCallback(() => {
        setIsProfileUnlinkConfirmationModalOpen(false);
    }, []);

    const getRequestAccessDataAPICall = useCallback((request_id: string) => {
        try {
            setIsRequestDataLoading(true);
            setIsRequestDataLoaded(false);
            CommonService._client.getRequestAccessDetails(request_id)
                .then((response: IAPIResponseType<any>) => {
                    setGetRequestAccessDetailsData(response?.data);
                    setIsRequestDataLoaded(true);
                    setIsRequestDataLoading(false);
                })
                .catch((error: any) => {
                    setGetRequestAccessDetailsData(null);
                    setIsRequestDataLoading(false);
                    setIsRequestDataLoaded(true);
                })
        } catch (error: any) {
            setGetRequestAccessDetailsData(null);
        }
    }, []);

    const getPendingRequestsCount = useCallback(() => {
        CommonService._client.getPendingRequestCsCount()
            .then((response: IAPIResponseType<any>) => {
                setCount(response?.data);
            }).catch((error: any) => {
            setCount(0);
        })
    }, []);

    useEffect(() => {
        getPendingRequestsCount()
    }, [getPendingRequestsCount]);


    const handleAccountDetails = useCallback((account: any) => {
        setSelectedProfile(account);
        setProfileFound(account.client_details);
        let accountDetailsObj;
        if (account?.permission_type === "mutual") {
            accountDetailsObj = {
                permission_type: 'mutual',
                relationship: account?.relationship,
            }
        } else {
            accountDetailsObj = {
                permission_type: 'non_mutual',
                relationship: account?.relationship,
            }
        }
        setAccountDetailsFormInitialValues(accountDetailsObj);
        setIsAccountDetailsDrawerOpen(true);
    }, []);

    const handleOpenWithdrawModal = useCallback(() => {
        setOpenWithdrawModal(true)
    }, []);

    const closeWithdrawModal = useCallback(() => {
        setOpenWithdrawModal(false);
    }, []);

    const handleWithdrawRequest = useCallback(() => {
        setIsRequestIsLoading(true);
        CommonService._client.cancelRequestedAccess(selectedProfile?._id, {})
            .then((response: IAPIResponseType<any>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                setOpenWithdrawModal(false);
                setIsRequestIsLoading(false);
                CommonService._communications.TableWrapperRefreshSubject.next({
                    moduleName: currentTab
                });
            }).catch((error: any) => {
            setOpenWithdrawModal(false);
            setIsRequestIsLoading(false);
            CommonService._alert.showToast(error.message, "error");
        })
    }, [selectedProfile, currentTab]);

    const columns: ITableColumn[] = useMemo<ITableColumn[]>(() => [
        {
            title: "",
            key: "name_avatar",
            dataIndex: "name_avatar",
            align: "center",
            width: 70,
            render: (record: any) =>
                <>
                    <div className={'account-list-profile-image-wrapper'}>
                        <AvatarComponent size={'xs'}
                                         title={record?.client_details?.first_name + " " + record?.client_details?.last_name}/>
                    </div>
                </>
        },
        {
            title: "Name",
            key: "date",
            dataIndex: "name",
            align: "left",
            width: 250,
            render: (record: any) => <>
                <div>{record?.client_details?.first_name} {record?.client_details?.last_name}</div>
            </>

        },
        {
            title: "Profile Status",
            key: "time",
            dataIndex: "time",
            align: "center",
            width: 180,

            headerIcon: {
                icon: <ToolTipComponent showArrow={true} position={'right'} tooltip={<>
                    <ul className={'pdd-10'}>
                        <li><b>One-Way:</b> This designation is used for one-way access requests, where the user is
                            granted
                            access without reciprocating permission.
                        </li>
                        <br/>
                        <li>
                            <b>Mutual:</b> This designation applies to mutual access requests, where both users grant
                            access to each other.
                        </li>
                    </ul>
                </>}>
                    <ImageConfig.InfoIcon className={'pdd-top-5'}/>
                </ToolTipComponent>,
                condition: true
            },
            render: (record: any) => (
                <>
                    {
                        ((currentUser?.current_user_id === record?.requested_by) || (record?.is_linked)) &&
                        <span>{record.profile_status}</span>
                    }
                </>
            )

        },
        {
            title: "Actions",
            key: "link_unlink",
            dataIndex: "link_unlink",
            align: "center",
            width: 250,
            render: (record: any) => {
                return (
                    <>
                        {(record.profile_status !== 'Dependent Profile') ?
                            <>
                                {record.is_linked && <LinkComponent
                                    className={''}
                                    onClick={() => {
                                        setSelectedProfile(record);
                                        handleProfileUnlinkConfirmationModalOpen();
                                    }}>
                                    <IconButtonComponent>
                                        <ImageConfig.UnlinkIcon/>
                                    </IconButtonComponent> &nbsp;
                                    Unlink Profile
                                </LinkComponent>
                                }
                                {
                                    (currentUser?.current_user_id === record?.requested_by) && !record.is_linked &&
                                    <LinkComponent onClick={() => {
                                        handleOpenWithdrawModal();
                                        setSelectedProfile(record);
                                    }}
                                    >
                                        <IconButtonComponent>
                                            <ImageConfig.CircularCrossedIcon/>
                                        </IconButtonComponent> &nbsp;
                                        Withdraw access
                                    </LinkComponent>
                                }

                            </>
                            :
                            <LinkComponent
                                className={''}
                                onClick={() => {
                                    setSelectedProfile(record);
                                    setIsUpdateProfileStatusDrawerOpen(true);
                                }}>
                                Update Status
                            </LinkComponent>}
                    </>
                );
            }
        },
        {
            title: "",
            key: "view_details",
            dataIndex: "view_details",
            align: "center",
            width: 150,
            render: (record: any) => {
                return (
                    <>
                        {
                            record?.is_linked &&
                            // (record.profile_status !== 'Dependent Profile' &&
                            <LinkComponent onClick={() => {
                                handleAccountDetails(record)
                            }}>
                                View details
                            </LinkComponent>
                        }{
                        (currentUser?.current_user_id === record?.requested_by && !record?.is_linked) && <LinkComponent
                            onClick={() => {
                                getRequestAccessDataAPICall(record._id)
                                setIsRequestDataDrawerOpen(true);

                            }}>View Details</LinkComponent>
                    }
                        {
                            (currentUser?.current_user_id !== record?.requested_by) && !record.is_linked && <> {

                                <ButtonComponent
                                    size={"small"}
                                    color={'error'}
                                    variant={'outlined'}
                                    onClick={() => {
                                        setSelectedProfile(record);
                                        setIsGrantAccessDrawerOpen(true)
                                    }}>
                                    Awaiting Response
                                </ButtonComponent>
                            }
                            </>
                        }
                    </>
                );
            }
        },
    ], [handleProfileUnlinkConfirmationModalOpen, handleOpenWithdrawModal, currentUser, getRequestAccessDataAPICall, handleAccountDetails]);

    const handleTabChange = useCallback((e: any, value: any) => {
        searchParams.set("currentStep", value);
        setSearchParams(searchParams);
        setCurrentTab(value);
    }, [searchParams, setSearchParams]);

    const onSubmit = useCallback((values: any, {setSubmitting, setErrors}: FormikHelpers<any>) => {
        setClientDetails({
            ...values,
            request_type: 'request_access'
        });
        setSubmitting(true);
        let payload: any = {
            ...values,
            request_type: 'request_access'
        };
        payload['dob'] = moment(payload['dob']).format('YYYY-MM-DD');
        CommonService._client.RequestAccessAPICall(payload)
            .then((response: IAPIResponseType<any>) => {
                setSubmitting(false);
                setMode('success');
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
            })
            .catch((error: any) => {
                CommonService.handleErrors(setErrors, error);
                setSubmitting(false);
            });
    }, []);

    const unLinkProfile = useCallback(() => {
        setIsRequestIsLoading(true);
        const payload = {};
        CommonService._client.UnlinkProfile(selectedProfile?._id, payload)
            .then((response: IAPIResponseType<any>) => {
                CommonService._communications.TableWrapperRefreshSubject.next({
                    moduleName: currentTab
                });
                setSelectedProfile(null);
                setIsRequestIsLoading(false)
                setIsProfileUnlinkConfirmationModalOpen(false);
                if (isAccountDetailsDrawerOpen) {
                    setIsAccountDetailsDrawerOpen(false);
                }
            })
            .catch((error: any) => {
                setSelectedProfile(null);
                setIsRequestIsLoading(false)
                setIsProfileUnlinkConfirmationModalOpen(false);
            });
    }, [selectedProfile, isAccountDetailsDrawerOpen, currentTab]);


    const editProfileLink = useCallback((values: any, {setSubmitting, setErrors}: FormikHelpers<any>) => {
        CommonService.onConfirm({
            image: ImageConfig.BlueConfirmationLottie,
            showLottie: true,
            confirmationSubTitle: <>
                Are you sure you want to resend<br/>
                the request
                to <b>{selectedProfile?.client_details?.first_name + " " + selectedProfile?.client_details?.last_name}</b>?
            </>
        }).then(() => {
            setSubmitting(true);
            const payload = {
                permission_type: values.permission_type,
                relationship: values.relationship,
            }
            CommonService._client.editProfileLinking(selectedProfile._id, payload)
                .then((response: IAPIResponseType<any>) => {
                    setSubmitting(false);
                    CommonService._communications.TableWrapperRefreshSubject.next({
                        moduleName: currentTab
                    });
                    setIsAccountDetailsDrawerOpen(false);
                })
                .catch((error: any) => {
                    setSubmitting(false);
                    CommonService.handleErrors(setErrors, error);
                });
        })
    }, [selectedProfile, currentTab]);

    const updateProfileStatus = useCallback((values: any, {setSubmitting, setErrors}: FormikHelpers<any>) => {
        setSubmitting(true);
        const payload = {...values,}
        CommonService._client.updateProfileStatus(selectedProfile.client_details._id, payload)
            .then((response: IAPIResponseType<any>) => {
                setSubmitting(false);
                setIsUpdateProfileStatusDrawerOpen(false);
                CommonService._communications.TableWrapperRefreshSubject.next({
                    moduleName: currentTab
                });
            })
            .catch((error: any) => {
                setSubmitting(false);
                CommonService.handleErrors(setErrors, error);
            });
    }, [selectedProfile, currentTab]);


    const cancelRequestedAccess = useCallback(() => {
        setCancelRequestLoading(true);
        const payload = {}
        CommonService._client.cancelRequestedAccess(selectedProfile?._id, payload)
            .then((response: IAPIResponseType<any>) => {
                setCancelRequestLoading(false);
                setIsRequestedAccessDrawerOpen(false);
                CommonService._communications.TableWrapperRefreshSubject.next({
                    moduleName: currentTab
                });
            })
            .catch((error: any) => {
                setIsRequestedAccessDrawerOpen(false);
            });
    }, [selectedProfile, currentTab]);

    const onSubmitGrantAccess = useCallback((values: any, {setSubmitting, setErrors}: FormikHelpers<any>) => {
        setClientDetails({
            ...values,
            request_type: 'grant_access'
        });
        setSubmitting(true);
        let payload: any = {
            ...values,
            request_type: 'grant_access'
        };
        payload['dob'] = moment(payload['dob']).format('YYYY-MM-DD');

        CommonService._client.RequestAccessAPICall(payload)
            .then((response: IAPIResponseType<any>) => {
                setSubmitting(false);
                setMode('success');
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
            })
            .catch((error: any) => {
                CommonService.handleErrors(setErrors, error);
                setSubmitting(false);
            });
    }, []);


    const handleEditRequestAccessDetails = useCallback((getRequestAccessDetailsData: any, id: string, mode: any) => {
        if (currentStep === "accountsICanAccess" || !currentStep) {
            setEditAccessStep('request')
        } else {
            setEditAccessStep('grant')
        }
        if (id && getRequestAccessDetailsData) {


            setRequestAccessFormInitialValues({
                ...getRequestAccessDetailsData,
                client_id: id,
                first_name: getRequestAccessDetailsData?.approver_details?.first_name,
                last_name: getRequestAccessDetailsData?.approver_details?.last_name,
                dob: getRequestAccessDetailsData?.approver_details?.dob,
                phone: getRequestAccessDetailsData?.approver_details?.primary_contact_info?.phone,
                relationship: getRequestAccessDetailsData?.relationship,

            })
        }
    }, [currentStep]);

    const onSubmitEditRequestAccess = useCallback((values: any, {setSubmitting, setErrors}: FormikHelpers<any>) => {
        setClientDetails(values)
        const payload = {...values,}
        CommonService._client.editProfileLinking(values?._id, payload)
            .then((response: IAPIResponseType<any>) => {
                CommonService._alert.showToast("success");
                setEditAccessStep('success')
            }).catch(error => {
            CommonService._alert.showToast(error.message, "error");
        })

    }, []);

    const approveClientRequest = useCallback((relationship?: string, permission_type?: string) => {
        setIsApproveClientRequestLoading(true);
        const payload = {
            relationship: relationship,
            permission_type: permission_type
        }
        CommonService._client.approveRequestAccess(selectedProfile?._id, payload)
            .then((response: IAPIResponseType<any>) => {
                    CommonService._alert.showToast("success");
                    setIsGrantAccessDrawerOpen(false);
                    getPendingRequestsCount();
                    CommonService._communications.TableWrapperRefreshSubject.next({
                        moduleName: currentTab
                    });
                    setIsApproveClientRequestLoading(false);
                }
            ).catch(error => {
            CommonService._alert.showToast(error.message, "error");
            setIsApproveClientRequestLoading(false);
        })
    }, [selectedProfile?._id, currentTab, getPendingRequestsCount]);

    const rejectClientRequest = useCallback(() => {
        CommonService._client.rejectRequestAccess(selectedProfile?._id)
            .then((response: IAPIResponseType<any>) => {
                    CommonService._alert.showToast("success");
                    getPendingRequestsCount();
                    setIsGrantAccessDrawerOpen(false);
                    CommonService._communications.TableWrapperRefreshSubject.next({
                        moduleName: currentTab
                    });
                }
            ).catch(error => {
            CommonService._alert.showToast(error.message, "error");
        })
    }, [selectedProfile?._id, currentTab, getPendingRequestsCount]);

    const handleRequestDataDrawerClose = useCallback(() => {
        setIsRequestDataDrawerOpen(false);
        setIsRequestAccessDrawerOpen(false)
        setEditAccessStep('view');
        CommonService._communications.TableWrapperRefreshSubject.next({
            moduleName: currentTab
        });
    }, [currentTab]);

    const closeDrawer = useCallback(() => {
        setIsGrantAccessDrawerOpen(false);
        setIsRequestDataDrawerOpen(false);
        CommonService._communications.TableWrapperRefreshSubject.next({
            moduleName: currentTab
        });
        getPendingRequestsCount()
    }, [currentTab, getPendingRequestsCount]);


    return (
        <div className={'profile-linking-layout-component'}>
            <div className={'profile-linking-header-section'}>
                <div className="profile-linking-layout-header-section">
                    <div className="profile-linking-layout-title">Link/Unlink Profile</div>
                </div>
                {count > 0 &&
                    <div className="profile-linking-pending-requests-count">
                        <ImageConfig.ContactIcon/> &nbsp;&nbsp;Pending Requests: {count}
                    </div>
                }
            </div>
            <div className='profile-linking-layout-component-body'>
                <TabsWrapperComponent>
                    <TabsComponent
                        value={currentTab}
                        allowScrollButtonsMobile={false}
                        variant={"fullWidth"}
                        onUpdate={handleTabChange}
                    >
                        <TabComponent className={'profile-linking-layout-tab'} label="Accounts I can access"
                                      value={"accountsICanAccess"}/>
                        <TabComponent className={'client-details-tab'}
                                      label="Accounts that have access to my account"
                                      value={"accountsThatHaveAccessToMyAccount"}/>
                    </TabsComponent>
                    <TabContentComponent value={"accountsICanAccess"} selectedTab={currentTab}>
                        <div className="profile-linking-layout-tab-body-header">
                            <div className="profile-linking-layout-tab-body-header-info">Below are the accounts that you
                                have been granted access to, and for which you can book
                                appointments and manage the account.
                            </div>
                            <div>
                                <ButtonComponent onClick={() => {
                                    setIsRequestAccessDrawerOpen(true);
                                    setRequestAccessFormInitialValues({})
                                }}>
                                    Request Access
                                </ButtonComponent>
                            </div>
                        </div>

                        <div className="list-wrapper">
                            <TableWrapperComponent
                                columns={columns}
                                extraPayload={refreshToken}
                                method={APIConfig.ACCESSIBLE_ACCOUNTS.METHOD}
                                url={APIConfig.ACCESSIBLE_ACCOUNTS.URL}
                                // columnGap={44}
                                isPaginated={false}
                                moduleName={currentTab}
                                noDataText={"No accounts have been added yet!"}
                            />
                        </div>
                    </TabContentComponent>
                    <TabContentComponent value={"accountsThatHaveAccessToMyAccount"} selectedTab={currentTab}>
                        <div className="profile-linking-layout-tab-body-header">
                            <div className="profile-linking-layout-tab-body-header-info">Below are the accounts that you
                                granted access to, and for which they can book appointments and manage your account.
                            </div>
                            <div>
                                <ButtonComponent onClick={() => {
                                    setIsRequestAccessDrawerOpen(true);
                                    setMode('grantAccess');
                                    setRequestAccessFormInitialValues({})
                                }}>
                                    Grant Access
                                </ButtonComponent>
                            </div>
                        </div>
                        <div className="list-wrapper">
                            <TableWrapperComponent
                                columns={columns}
                                extraPayload={refreshToken}
                                method={APIConfig.MY_ACCOUNT_ACCESSORS.METHOD}
                                url={APIConfig.MY_ACCOUNT_ACCESSORS.URL}
                                // columnGap={44}
                                isPaginated={false}
                                moduleName={currentTab}
                                noDataText={"No accounts have been added yet!"}
                            />
                        </div>
                    </TabContentComponent>
                </TabsWrapperComponent>
            </div>

            <ModalComponent
                isOpen={isProfileUnlinkConfirmationModalOpen}
                onClose={handleProfileUnlinkConfirmationModalClose}
            >
                <div className="modal__content">
                    <div className={'confirm-popup-component width-350'}>
                        <div className={'confirm-popup-image'}>
                            <LottieFileGenarationComponent
                                loop={true}
                                autoplay={true}
                                animationData={ImageConfig.BlueConfirmationLottie}/>
                        </div>
                        <div className="confirm-popup-meta">
                            <div className={'confirm-popup-description font-size-18 d-inline-block'}>
                                Are you sure you want to unlink your <br/>
                                account
                                from <b
                                className="text-color-primary"> {selectedProfile?.client_details?.first_name} {selectedProfile?.client_details?.last_name} </b>?
                            </div>
                            <div className={'confirm-popup-continue-and-cancel-cta pdd-top-15'}>
                                <ButtonComponent
                                    className="mrg-right-10"
                                    variant={"outlined"}
                                    fullWidth={true}
                                    color={"default"}
                                    onClick={handleProfileUnlinkConfirmationModalClose}>No</ButtonComponent>
                                <ButtonComponent
                                    className="mrg-left-10"
                                    fullWidth={true}
                                    isLoading={isRequestIsLoading}
                                    color={"accent"}
                                    onClick={() => {
                                        unLinkProfile();
                                    }}
                                >Yes</ButtonComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalComponent>


            <ModalComponent
                isOpen={openWithdrawModal}
                onClose={closeWithdrawModal}
            >
                <div className="modal__content">
                    <div className={'confirm-popup-component width-350'}>
                        <div className={'confirm-popup-image'}>
                            <LottieFileGenarationComponent
                                loop={true}
                                autoplay={true}
                                animationData={ImageConfig.BlueConfirmationLottie}/>
                        </div>
                        <div className="confirm-popup-meta">
                            <div className={'confirm-popup-description font-size-18 d-inline-block'}>
                                Are you sure you want to withdraw the access <br/>
                                request sent to <b
                                className="text-color-primary"> {selectedProfile?.client_details?.first_name} {selectedProfile?.client_details?.last_name} </b>?
                            </div>

                            <div className={'confirm-popup-continue-and-cancel-cta pdd-top-15'}>
                                <ButtonComponent
                                    className="mrg-right-10"
                                    variant={"outlined"}
                                    fullWidth={true}
                                    color={"default"}
                                    onClick={closeWithdrawModal}>No</ButtonComponent>
                                <ButtonComponent
                                    className="mrg-left-10"
                                    fullWidth={true}
                                    isLoading={isRequestIsLoading}
                                    color={"accent"}
                                    onClick={() => {
                                        handleWithdrawRequest();
                                    }}
                                >Yes</ButtonComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalComponent>

            <DrawerComponent
                isOpen={isRequestAccessDrawerOpen}
                closeOnEsc={false}
                hideBackdrop={false}
                showClose={true}
                direction={"right"}
                title={`${mode !== 'success' ? (mode === 'requestAccess' ? 'Request Access' : 'Grant Access') : ''}`}
                onClose={(reason) => {
                    setIsRequestAccessDrawerOpen(false);
                    setMode('requestAccess');
                    setRefreshToken(Math.random().toString(36).substring(2, 15));
                }}
            >
                {mode === 'requestAccess' &&
                    <RequestAccessFormComponent requestAccessFormValidationSchema={requestAccessFormValidationSchema}
                                                requestAccessFormInitialValues={requestAccessFormInitialValues}
                                                mutual_access_object={mutual_access_object}
                                                onSubmit={onSubmit}
                                                accessType={'request'}
                                                onCancel={handleRequestDataDrawerClose}
                                                no_mutual_access_object={no_mutual_access_object}
                                                setIsRequestAccessDrawerOpen={setIsRequestAccessDrawerOpen}
                    />
                }
                {
                    mode === 'success' &&
                    <SuccessStatusComponent clientDetails={clientDetails}/>

                }
                {mode === 'grantAccess' &&
                    <RequestAccessFormComponent requestAccessFormValidationSchema={requestAccessFormValidationSchema}
                                                requestAccessFormInitialValues={requestAccessFormInitialValues}
                                                mutual_access_object={mutual_access_object}
                                                onSubmit={onSubmitGrantAccess}
                                                accessType={'grant'}
                                                onCancel={handleRequestDataDrawerClose}
                                                no_mutual_access_object={no_mutual_access_object}
                                                setIsRequestAccessDrawerOpen={setIsRequestAccessDrawerOpen}/>
                }

            </DrawerComponent>

            <DrawerComponent
                isOpen={isAccountDetailsDrawerOpen}
                closeOnEsc={false}
                hideBackdrop={false}
                showClose={true}
                direction={"right"}
                title={`${viewDetailsStep === 'view' ? 'View Account Details' : 'Update Permission'}`}
                className={"account-details-drawer"}
                onClose={(reason) => {
                    setIsAccountDetailsDrawerOpen(false);
                    setViewDetailsStep('view')
                }}
            >
                <ViewAccountDetailsComponent profileFound={profileFound}
                                             editProfileLink={editProfileLink}
                                             unLinkProfile={handleProfileUnlinkConfirmationModalOpen}
                                             viewDetailsStep={viewDetailsStep}
                                             setViewDetailsStep={setViewDetailsStep}
                                             selectedProfile={selectedProfile}
                                             accountDetailFormInitialValues={accountDetailFormInitialValues}
                                             no_mutual_access_object={no_mutual_access_object}
                                             mutual_access_object={mutual_access_object}
                />

            </DrawerComponent>


            <DrawerComponent
                isOpen={isUpdateProfileStatusDrawerOpen}
                closeOnEsc={false}
                hideBackdrop={false}
                showClose={true}
                direction={"right"}
                className={"update-profile-status-drawer"}
                onClose={(reason) => {
                    setIsUpdateProfileStatusDrawerOpen(false);
                }}
            >
                <div>
                    <div className="drawer-header">Update Profile Status</div>
                    <div className="update-profile-status-description">Please enter the following information below:
                    </div>
                    <Formik
                        validationSchema={upGradeProfileFormValidationSchema}
                        initialValues={upGradeProfileInitialValues}
                        validateOnChange={false}
                        validateOnBlur={true}
                        enableReinitialize={true}
                        validateOnMount={true}
                        onSubmit={updateProfileStatus}
                    >
                        {({values, validateForm, isValid, isSubmitting, dirty}) => {
                            // eslint-disable-next-line react-hooks/rules-of-hooks
                            useEffect(() => {
                                validateForm();
                            }, [validateForm, values, dirty]);
                            return (
                                <Form className="t-form" noValidate={true}>
                                    <div className="t-form-controls">
                                        <Field name={'primary_email'} className="t-form-control">
                                            {
                                                (field: FieldProps) => (
                                                    <FormikInputComponent
                                                        id={'email_input'}
                                                        label={'Email Address'}
                                                        placeholder={'Enter Email Address'}
                                                        type={"email"}
                                                        required={true}
                                                        formikField={field}
                                                        fullWidth={true}
                                                    />
                                                )
                                            }
                                        </Field>

                                        <Field name={'primary_contact_info.phone'} className="t-form-control">
                                            {
                                                (field: FieldProps) => (
                                                    <FormikPhoneInputComponent
                                                        label={'Cell Phone Number'}
                                                        placeholder={'(000) 000-0000'}
                                                        formikField={field}
                                                        required={true}
                                                        fullWidth={true}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </div>
                                    <div className="t-form-actions">
                                        <ButtonComponent
                                            color={'accent'}
                                            variant={'outlined'}
                                            className='width-40'
                                            onClick={() => {
                                                setIsUpdateProfileStatusDrawerOpen(false);
                                            }}
                                        >
                                            Cancel
                                        </ButtonComponent>
                                        <ButtonComponent
                                            color={'accent'}
                                            type={'submit'}
                                            disabled={!isValid}
                                            className={'mrg-left-10 width-40'}
                                            isLoading={isSubmitting}
                                            variant={'contained'}>
                                            Update
                                        </ButtonComponent>
                                    </div>
                                </Form>
                            )
                        }}
                    </Formik>
                </div>
            </DrawerComponent>

            <DrawerComponent
                isOpen={isGrantAccessDrawerOpen}
                closeOnEsc={false}
                hideBackdrop={false}
                showClose={true}
                direction={"right"}
                className={"grant-access-drawer"}
                onClose={(reason) => {
                    setIsGrantAccessDrawerOpen(false);
                }}
            >
                <ReviewPendingComponent approveClientRequest={approveClientRequest}
                                        rejectClientRequest={rejectClientRequest}
                                        isApproveClientRequestLoading={isApproveClientRequestLoading}
                                        closeDrawer={closeDrawer}
                                        selectedProfile={selectedProfile}/>
            </DrawerComponent>
            <DrawerComponent
                isOpen={isRequestDataDrawerOpen}
                closeOnEsc={true}
                className={'request-data-details-drawer'}
                title={editAccessStep === 'success' ? '' : (editAccessStep === 'view' ? 'View Details' : `${editAccessStep === 'request' ? 'Request Access' : 'Grant Access'}`)}
                onClose={handleRequestDataDrawerClose}
                hideBackdrop={false}
                showClose={true}>
                {
                    isRequestDataLoading && <div className={'loader-container'}>
                        <LoaderComponent/>
                    </div>
                }
                {
                    isRequestDataLoaded && editAccessStep === 'view' && getRequestAccessDetailsData &&
                    <ViewAccessDetailsComponent handleEditRequestAccessDetails={handleEditRequestAccessDetails}
                                                getRequestAccessDetailsData={getRequestAccessDetailsData}
                                                currentUser={currentUser}
                                                currentTab={currentTab}
                                                closeDrawer={closeDrawer}
                                                handleOpenWithdrawModal={handleOpenWithdrawModal}
                    />
                }
                {
                    editAccessStep === 'request' &&
                    <RequestAccessFormComponent requestAccessFormValidationSchema={requestAccessFormValidationSchema}
                                                requestAccessFormInitialValues={requestAccessFormInitialValues}
                                                mutual_access_object={mutual_access_object}
                                                onSubmit={onSubmitEditRequestAccess}
                                                accessType={'request'}
                                                onCancel={handleRequestDataDrawerClose}
                                                setEditAccessStep={setEditAccessStep}
                                                no_mutual_access_object={no_mutual_access_object}
                                                setIsRequestAccessDrawerOpen={setIsRequestAccessDrawerOpen}
                    />
                }
                {editAccessStep === 'grant' &&
                    <RequestAccessFormComponent requestAccessFormValidationSchema={requestAccessFormValidationSchema}
                                                requestAccessFormInitialValues={requestAccessFormInitialValues}
                                                mutual_access_object={mutual_access_object}
                                                onSubmit={onSubmitEditRequestAccess}
                                                accessType={'grant'}
                                                onCancel={handleRequestDataDrawerClose}
                                                setEditAccessStep={setEditAccessStep}
                                                no_mutual_access_object={no_mutual_access_object}
                                                setIsRequestAccessDrawerOpen={setIsRequestAccessDrawerOpen}/>
                }
                {
                    editAccessStep === 'success' && <div>
                        <SuccessStatusComponent clientDetails={clientDetails}/>

                    </div>

                }

            </DrawerComponent>


            <DrawerComponent
                isOpen={isRequestedAccessDrawerOpen}
                closeOnEsc={false}
                hideBackdrop={false}
                showClose={true}
                direction={"right"}
                className={"requested-access-drawer"}
                onClose={(reason) => {
                    setIsRequestedAccessDrawerOpen(false);
                }}
            >
                <div>
                    <div className="drawer-header">Requested Access</div>
                    <div className="requested-access-drawer-body">
                        <div className="requested-access-drawer-content">
                            <ProfileFoundCardComponent profileDetails={selectedProfile?.client_details}/>
                            <div className="pdd-top-20">
                                <div className="drawer-header">Permissions</div>
                                <div
                                    className="requested-access_permission_type">{selectedProfile?.permission_type === 'non_mutual' ? 'One-Way Access' : 'Mutual Access'}</div>
                            </div>
                        </div>
                        <div className="requested-access-drawer-actions">
                            <ButtonComponent
                                color={'accent'}
                                isLoading={cancelRequestLoading}
                                onClick={() => cancelRequestedAccess()}
                                variant={'outlined'}>
                                Cancel Request
                            </ButtonComponent>
                        </div>
                    </div>
                </div>
            </DrawerComponent>
        </div>
    );

};

export default ProfileLinkingLayoutComponent;
